import * as React from 'react';
import '../../styles/css/index.css';
import LanguageSelector from '../LanguageSelector';

import ConfigurationValuesService, { IConfigurationValuesService } from '../../services/ConfigurationValuesService';
export interface Props {
    error: boolean;
}

const imageSrc = 'images/logo-sj.png';

class Header extends React.Component<Props> {
    private readonly configurationValuesService: IConfigurationValuesService;

    constructor(props: any) {
        super(props);
        this.configurationValuesService = ConfigurationValuesService.getInstance();
    }

    public render() {
        const showCustomTranslatorTemplate = this.configurationValuesService.showCustomTranslatorTemplate;
        const preferredLogoUrl = this.configurationValuesService.preferredLogoUrl;
        return (
            <div className='header'>
                <div className={`header-content ${showCustomTranslatorTemplate && 'content-flex-end'}`}>
                    {!showCustomTranslatorTemplate &&
                        <img className='logo-image'
                             src={preferredLogoUrl || imageSrc} />
                    }
                    {
                        !this.props.error &&
                        <LanguageSelector />
                    }
                </div>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx